import gql from "graphql-tag"

import { CartFields, CustomerAccountFields, OrderFields } from "./fragments"

export const GetCart = gql`
  ${CartFields}
  query GetCart($cartId: ID!, $cartCountry: CountryCode)
  @inContext(country: $cartCountry) {
    cart(id: $cartId) {
      ...CartFields
    }
  }
`

export const GetCustomerAccount = /* GraphQL */ `
  ${CustomerAccountFields}
  query GetCustomerAccount {
    customer {
      ...CustomerAccountFields
    }
  }
`

export const GetOrderStatus = gql`
  ${OrderFields}
  query GetOrderStatus($query: String!) {
    orders(first: 1, query: $query) {
      edges {
        node {
          ...OrderFields
        }
      }
    }
  }
`
